import type { TranslationMessages } from '../types';

export const settings: TranslationMessages = {
  name: 'Cài đặt',
  title: 'Cài đặt',
  modernOnly: 'Trang cài đặt này chỉ có sẵn trong phiên bản hiện đại.',
  currency: {
    title: 'Cài đặt Tiền tệ',
    subtitle: 'Cấu hình cách hiển thị tiền tệ trong toàn bộ ứng dụng',
    presets: 'Tiền tệ Phổ biến',
    custom: 'Cài đặt Tùy chỉnh',
    symbol: 'Ký hiệu Tiền tệ',
    symbolHelp: 'Ký hiệu để hiển thị (ví dụ: $, €, ₫)',
    code: 'Mã Tiền tệ',
    codeHelp: 'Mã tiền tệ ba chữ cái (ví dụ: USD, EUR, VND)',
    precision: 'Số thập phân',
    precisionHelp: 'Số chữ số thập phân để hiển thị (0-4)',
    position: 'Vị trí Ký hiệu',
    positionBefore: 'Trước số tiền ($100)',
    positionAfter: 'Sau số tiền (100₫)',
    thousandsSeparator: 'Dấu phân cách Hàng nghìn',
    thousandsSeparatorHelp: 'Ký tự để phân cách hàng nghìn (ví dụ: , hoặc .)',
    decimalSeparator: 'Dấu phân cách Thập phân',
    decimalSeparatorHelp: 'Ký tự để phân cách thập phân (ví dụ: . hoặc ,)',
    reset: 'Đặt lại Mặc định',
    preview: 'Xem trước',
    previewAmount: 'Số tiền để xem trước',
    previewDescription:
      'Xem cách cài đặt tiền tệ của bạn sẽ hiển thị trong ứng dụng',
  },
  notifications: {
    title: 'Cài đặt Thông báo',
    subtitle: 'Cấu hình tùy chọn thông báo cho tổ chức của bạn',
    reset: 'Đặt lại Mặc định',
    info: 'Cấu hình khi nào thông báo được gửi dựa trên mức tồn kho. Ngưỡng phải theo thứ tự: Nghiêm trọng < Thấp < Trung bình.',
    global: 'Cài đặt Toàn cục',
    enabled: 'Bật tất cả thông báo',
    enabledHelp:
      'Công tắc chính để bật hoặc tắt tất cả thông báo. Các danh mục riêng lẻ vẫn có thể được kiểm soát bên dưới.',
    inventoryStock: 'Thông báo Tồn kho',
    inventoryStockEnabled: 'Bật thông báo tồn kho',
    inventoryStockEnabledHelp:
      'Nhận cảnh báo khi mức tồn kho giảm xuống dưới ngưỡng đã cấu hình.',
    thresholds: 'Ngưỡng Mức Tồn kho',
    criticalThreshold: 'Ngưỡng Nghiêm trọng',
    criticalThresholdHelp: 'Cảnh báo khi tồn kho ≤ mức này (ưu tiên NGHIÊM TRỌNG)',
    lowThreshold: 'Ngưỡng Thấp',
    lowThresholdHelp: 'Cảnh báo khi tồn kho ≤ mức này (ưu tiên CAO)',
    mediumThreshold: 'Ngưỡng Trung bình',
    mediumThresholdHelp: 'Ngưỡng tham chiếu (không được sử dụng cho thông báo)',
    thresholdOrderWarning: 'Ngưỡng phải theo thứ tự: Nghiêm trọng < Thấp < Trung bình',
    howItWorks: 'Cách Hoạt động',
    howItWorksDescription:
      'Khi số lượng tồn kho giảm xuống dưới các ngưỡng đã cấu hình, thông báo sẽ được gửi đến quản lý cửa hàng và quản trị viên tổ chức. Thông báo được gửi qua các kênh thời gian thực và xuất hiện trong trung tâm thông báo.',
    orderNotifications: 'Thông báo Đơn hàng',
    orderNotificationsEnabled: 'Bật tất cả thông báo đơn hàng',
    orderNotificationsEnabledHelp: 'Công tắc chính cho tất cả thông báo liên quan đến đơn hàng.',
    orderNew: 'Thông báo Đơn hàng Mới',
    orderNewHelp: 'Thông báo khi có đơn hàng mới được đặt',
    orderReady: 'Thông báo Đơn hàng Sẵn sàng',
    orderReadyHelp: 'Thông báo khi đơn hàng được đánh dấu là sẵn sàng',
    orderDelivered: 'Thông báo Đơn hàng Đã giao',
    orderDeliveredHelp: 'Thông báo khi đơn hàng được giao',
    orderCancelled: 'Thông báo Đơn hàng Đã hủy',
    orderCancelledHelp: 'Thông báo khi đơn hàng bị hủy',
    staffNotifications: 'Thông báo Nhân viên',
    staffNotificationsEnabled: 'Bật thông báo nhân viên',
    staffNotificationsEnabledHelp:
      'Nhận thông báo về hoạt động nhân viên, điểm danh và thay đổi ca làm việc.',
    generalNotifications: 'Thông báo Chung',
    generalNotificationsEnabled: 'Bật thông báo chung',
    generalNotificationsEnabledHelp:
      'Nhận thông báo hệ thống chung và thông báo.',
  },
  staff: {
    title: 'Cài đặt Nhân viên',
    fetch_failed: 'Không thể tải cài đặt nhân viên',
    save_success: 'Cài đặt nhân viên đã được cập nhật thành công',
    save_failed: 'Không thể cập nhật cài đặt nhân viên',
    paid_leave_title: 'Cài đặt Nghỉ phép Có lương',
    paid_leave_desc:
      'Cấu hình cách phân bổ và quản lý ngày nghỉ có lương cho nhân viên',
    allowance_label: 'Phụ cấp Ngày nghỉ Có lương Hàng năm',
    allowance_hint: 'Số ngày nghỉ có lương nhân viên nhận được mỗi năm',
    wipe_policy_label: 'Chính sách Cuối năm',
    wipe_policy_hint:
      'Chỉ định xem các ngày chưa sử dụng có được chuyển sang năm sau hay đặt lại vào cuối năm',
    wipe_option: 'Xóa (Đặt lại về không)',
    keep_option: 'Giữ (Chuyển sang năm sau)',
    fiscal_start_label: 'Tháng Bắt đầu Năm Tài chính',
    fiscal_start_hint: 'Tháng khi phụ cấp nghỉ phép được đặt lại',
    standard_hours_label: 'Giờ Làm việc Tiêu chuẩn Hàng tuần',
    standard_hours_hint: 'Giờ làm việc mục tiêu mỗi tuần cho nhân viên toàn thời gian',
    effective_policy: 'Chính sách Nhân viên Hiệu quả',
    currently_using: 'Hiện đang sử dụng',
    rules: 'quy tắc',
    paid_time_off: 'Nghỉ phép Có lương:',
    weekly_load: 'Tải Hàng tuần:',
    daily_load: 'Tải Hàng ngày:',
    configuration_hierarchy: 'Phân cấp Cấu hình',
    hierarchy_description:
      'Cài đặt được áp dụng theo thứ tự ưu tiên: Hàng tuần → Hàng tháng → Hàng năm. Bật cài đặt có mức ưu tiên cao hơn sẽ ghi đè các cài đặt thấp hơn.',
    weekly_settings: 'Cài đặt Hàng tuần',
    enable_weekly_rules: 'Bật Quy tắc Hàng tuần',
    specific_days_off: 'Ngày Nghỉ Cụ thể',
    days_off_count_per_week: 'Hoặc Số Ngày Nghỉ (Mỗi Tuần)',
    standard_weekly_hours: 'Giờ Tiêu chuẩn Hàng tuần',
    standard_daily_hours: 'Giờ Tiêu chuẩn Hàng ngày',
    monthly_settings: 'Cài đặt Hàng tháng',
    enable_monthly_rules: 'Bật Quy tắc Hàng tháng',
    days_off_per_month: 'Số Ngày Nghỉ mỗi Tháng',
    days_per_year: 'ngày/năm',
    hours_per_week: 'giờ/tuần',
    hours_per_day: 'giờ/ngày',
    policies: 'Chính sách',
    annual_paid_day_off_allowance: 'Phụ cấp Nghỉ phép Có lương Hàng năm',
    annual_allowance_hint: 'Tổng số ngày mỗi năm. Được sử dụng nếu không có quy tắc Hàng tuần/Hàng tháng áp dụng.',
    fiscal_year_start_month: 'Tháng Bắt đầu Năm Tài chính',
    reset_policy: 'Chính sách Đặt lại',
    wipe_monthly: 'Xóa Hàng tháng (Đặt lại mỗi tháng)',
    wipe_yearly: 'Xóa Hàng năm (Đặt lại vào cuối năm tài chính)',
    keep_accumulate: 'Giữ (Tích lũy vô thời hạn)',
    highest_priority: 'Ưu tiên Cao nhất',
    overrides_policies: 'Ghi đè Chính sách',
    days_of_week: {
      monday: 'Thứ Hai',
      tuesday: 'Thứ Ba',
      wednesday: 'Thứ Tư',
      thursday: 'Thứ Năm',
      friday: 'Thứ Sáu',
      saturday: 'Thứ Bảy',
      sunday: 'Chủ Nhật',
    },
  },
  sensitiveData: {
    title: 'Bảo vệ Dữ liệu Nhạy cảm',
    description:
      'Cấu hình các trường nào nên được làm mờ khi chụp ảnh màn hình, báo cáo lỗi hoặc gửi ảnh màn hình cho trợ lý AI',
    noPermission:
      'Bạn không có quyền truy cập cài đặt dữ liệu nhạy cảm. Chỉ quản trị viên và quản lý cửa hàng mới có thể truy cập trang này.',
    info: 'Làm mờ được kích hoạt tự động khi bạn chụp ảnh màn hình, báo cáo lỗi hoặc gửi ảnh màn hình cho trợ lý AI. Sử dụng nút xem trước để kiểm tra cấu hình của bạn.',
    globalSettings: 'Cài đặt Toàn cục',
    globalSettingsDescription: 'Bật hoặc tắt làm mờ dữ liệu nhạy cảm toàn cục',
    enableBlurring: 'Bật Làm mờ Dữ liệu Nhạy cảm',
    enableBlurringDescription:
      'Khi được bật, dữ liệu nhạy cảm sẽ được làm mờ tự động trong ảnh màn hình, báo cáo lỗi và tương tác với trợ lý AI',
    blurIntensity: 'Cường độ Làm mờ',
    blurIntensityDescription: 'Giá trị cao hơn tạo ra độ mờ mạnh hơn. Khuyến nghị: 8',
    fieldConfiguration: 'Cấu hình Trường',
    fieldConfigurationDescription:
      'Cấu hình các trường nào nên được làm mờ. Các trường được phát hiện tự động dựa trên bộ chọn CSS và thuộc tính dữ liệu.',
    preview: 'Xem trước',
    reset: 'Đặt lại',
    save: 'Lưu',
    enabled: 'Làm mờ dữ liệu nhạy cảm đã được bật',
    disabled: 'Làm mờ dữ liệu nhạy cảm đã được tắt',
    fieldEnabled: 'Đã bật làm mờ cho trường',
    fieldDisabled: 'Đã tắt làm mờ cho trường',
    previewStopped: 'Đã dừng xem trước',
    previewStoppedAndClosed: 'Đã dừng xem trước và đóng tab',
    previewWindowOpened:
      'Cửa sổ xem trước đã mở - làm mờ đang hoạt động trong tab mới',
    allowPopups: 'Vui lòng cho phép cửa sổ bật lên để mở cửa sổ xem trước',
    resetToDefault: 'Đặt lại về cấu hình mặc định',
    settingsSaved: 'Cài đặt đã được lưu thành công',
    maximum: 'Tối đa',
    categories: {
      personal: 'Thông tin Cá nhân',
      financial: 'Thông tin Tài chính',
      contact: 'Thông tin Liên hệ',
      identification: 'Nhận dạng',
      other: 'Khác',
    },
    table: {
      field: 'Trường',
      description: 'Mô tả',
      selector: 'Bộ chọn',
      enabled: 'Đã bật',
    },
  },
  payment: {
    title: 'Cài đặt Thanh toán',
    subtitle: 'Cấu hình mã QR thanh toán cho hóa đơn',
    reset: 'Đặt lại',
    info: 'Cấu hình mã QR thanh toán sẽ được bao gồm trong hóa đơn in. Bạn có thể tải lên hình ảnh mã QR hiện có hoặc nhập thông tin thanh toán để tạo tự động.',
    uploadQRImage: 'Tải lên Hình ảnh Mã QR',
    uploadQRImageHelp:
      'Tải lên hình ảnh mã QR hiện có. Nếu bạn tải lên hình ảnh, dữ liệu văn bản bên dưới sẽ bị bỏ qua.',
    removeImage: 'Xóa',
    invalidImageType: 'Vui lòng tải lên tệp hình ảnh',
    imageTooLarge: 'Kích thước hình ảnh phải nhỏ hơn 2MB',
    imageUploadError: 'Không thể đọc tệp hình ảnh',
    or: 'hoặc',
    generateAutomatically: 'tạo tự động',
    qrCodeData: 'Dữ liệu Mã QR',
    qrCodeDataPlaceholder:
      'Nhập thông tin thanh toán (ví dụ: tài khoản ngân hàng, ví điện tử, liên kết thanh toán)',
    qrCodeDataHelp:
      'Dữ liệu này sẽ được mã hóa vào mã QR. Khách hàng có thể quét để thanh toán. Để trống nếu bạn đã tải lên hình ảnh ở trên.',
    qrCodeLabel: 'Nhãn Mã QR',
    qrCodeLabelPlaceholder: 'Quét để Thanh toán',
    qrCodeLabelHelp: 'Nhãn tùy chọn hiển thị phía trên mã QR trên hóa đơn',
    includeInReceipt: 'Bao gồm trong Hóa đơn',
    includeInReceiptHelp: 'Hiển thị mã QR trong chân trang của hóa đơn in',
    preview: 'Xem trước',
    hidePreview: 'Ẩn',
    showPreview: 'Hiển thị',
    previewError:
      'Không thể tạo xem trước mã QR. Vui lòng kiểm tra dữ liệu mã QR của bạn.',
  },
  fiscalMonth: {
    title: 'Cài đặt Tháng Tài chính',
    subtitle: 'Cấu hình các kỳ tháng tài chính tùy chỉnh cho báo cáo',
    info: 'Tháng tài chính cho phép bạn xác định các kỳ tháng tùy chỉnh không khớp với tháng lịch. Ví dụ: tháng tài chính bắt đầu vào ngày 15 chạy từ ngày 15 của tháng này đến ngày 14 của tháng tiếp theo.',
    enable: 'Bật Tháng Tài chính',
    enableDescription: 'Sử dụng các kỳ tháng tài chính tùy chỉnh thay vì tháng lịch',
    reset: 'Đặt lại Mặc định',
    configuration: 'Cấu hình',
    startDay: 'Ngày Bắt đầu Tháng Tài chính',
    startDayHelp: 'Ngày trong tháng khi mỗi tháng tài chính bắt đầu (1-31)',
    presets: 'Cài đặt Nhanh',
    calendarMonth: 'Lịch (ngày 1)',
    midMonth: 'Giữa tháng (ngày 15)',
    endMonth: 'Cuối tháng (ngày 25)',
    preview: 'Xem trước',
    previewDate: 'Ngày Xem trước',
    fiscalPeriod: 'Kỳ Tài chính',
    start: 'Bắt đầu',
    end: 'Kết thúc',
    previewDescription:
      'Điều này hiển thị kỳ tháng tài chính chứa ngày đã chọn',
    disabledMessage:
      'Tháng tài chính hiện đang bị tắt. Bật chúng ở trên để cấu hình các kỳ tháng tùy chỉnh.',
  },
};
